<div class="card" data-testid="project-references">
  @if (hasReferences()) {
    @if (isEditable()) {
      <app-project-references-filter
        class="block mb-4"
        [references]="references()"
        [industryOptions]="industryOptions()"
        [moduleGroups]="moduleGroups()"
        [countryOptions]="countryOptions()"
        [languageOptions]="languageOptions()"
        [(filter)]="filter"
      />
    }

    <div class="flex flex-col gap-4" data-testid="project-references-list">
      @for (entry of referenceEntries(); track entry.reference.localId; let i = $index) {
        <app-project-reference-card
          [class.hidden]="entry.isHidden"
          [reference]="entry.reference"
          [position]="i + 1"
          [total]="referenceCount()"
          [industryOptions]="industryOptions()"
          [moduleGroups]="moduleGroups()"
          [functionStatusOptions]="functionStatusOptions()"
          [countryOptions]="countryOptions()"
          [languageOptions]="languageOptions()"
          [readOnly]="readOnly()"
          [score]="entry.score"
          (save)="saveReference($event)"
          (hasChangesChange)="onReferenceChanges(entry.reference.localId, $event)"
          (remove)="removeReference($event)"
        />
      }
    </div>

    @if (hasNoMatchingReferences()) {
      <app-no-data label="common.filter.noMatch" testId="no-matching-project-references-message" />
    }
  } @else {
    <app-no-data label="common.item.empty" testId="no-project-references-message" />
  }

  @if (isEditable()) {
    <div class="mt-3">
      <app-add-item-button testId="project-reference-add-btn" (add)="addReference()" />
    </div>
  }
</div>
